<!-- eslint-disable -->
<template lang="pug">
    .exercise
        .exercise__header
            .exercise__image-box
                img.exercise__image(:src="imageSrcString")
            span {{ getGameName(exercise) }}
        .exercise__item.exercise__body(
            :is="getPreview(exercise.slug)"
            :game="exercise"
            :userId="userId"
        )
        .exercise__item.exercise__done(v-if="isExerciseCompleted(exercise)")
            svg-icon.exercise__done-icon(name="circle-check", size="x-large")
            | {{ $i18n.t('profiles.profiles_userExercisePreview_done') }}
        .exercise__item.exercise__button(v-else)
            cs-button(
                :loading="isLoading",
                color="green",
                @click="countExercise(exercise)"
            )
                | {{ $i18n.t('profiles.profiles_userExercisePreview_count') }}
</template>

<script>
    /*eslint-disable*/
    const AddSubPreview = () => import('../../games/games-previews/AddSubPreview.vue');
    const FlashCardsPreview = () => import('../../games/games-previews/FlashCardsPreview.vue');
    const MultDivPreview = () => import('../../games/games-previews/MultDivPreview.vue');
    const TabularMultiplicationPreview = () => import('../../games/games-previews/TabularMultiplicationPreview.vue');
    const EquationPreview = () => import('../../games/games-previews/EquationPreview.vue');
    const FactorizationPreview = () => import('../../games/games-previews/FactorizationPreview.vue');
    const EquationMultiplicationPreview = () => import('../../games/games-previews/EquationMultiplicationPreview.vue');
    const AnzanPreview = () => import('../../games/games-previews/AnzanPreview.vue');
    const PuzzlePreview = () => import('../../games/games-previews/PuzzlePreview.vue');
    const CouplesPreview = () => import('../../games/games-previews/CouplesPreview.vue');
    const CouplesReadingEnPreview = () => import('../../games/games-previews/CouplesReadingEnPreview.vue');
    const ChainsPreview = () => import('../../games/games-previews/ChainsPreview.vue');
    const ChainsReadingEnPreview = () => import('../../games/games-previews/ChainsReadingEnPreview.vue');
    const WordsFieldPreview = () => import('../../games/games-previews/WordsFieldPreview.vue');
    const WordsFieldReadingEnPreview = () => import('../../games/games-previews/WordsFieldReadingEnPreview.vue');
    const ScannerPreview = () => import('../../games/games-previews/ScannerPreview.vue');
    const ShutterPreview = () => import('../../games/games-previews/ShutterPreview.vue');
    const ShutterReadingEnPreview = () => import('../../games/games-previews/ShutterReadingEnPreview.vue');
    const ShutterRussianLanguagePreview = () => import('../../games/games-previews/ShutterRussianLanguagePreview.vue');
    const AnagramsPreview = () => import('../../games/games-previews/AnagramsPreview.vue');
    const TextsPreview = () => import('../../games/games-previews/TextsPreview.vue');
    const LettersFieldPreview = () => import('../../games/games-previews/LettersFieldPreview.vue');
    const CatchWordPreview = () => import('../../games/games-previews/CatchWordPreview.vue');
    const CatchWordReadingEnPreview = () => import('../../games/games-previews/CatchWordReadingEnPreview.vue');
    const MatrixPreview = () => import('../../games/games-previews/MatrixPreview.vue');
    const NavigatorPreview = () => import('../../games/games-previews/NavigatorPreview.vue');
    const SynonymsPreview = () => import('../../games/games-previews/SynonymsPreview.vue');
    const SynonymsReadingEnPreview = () => import('../../games/games-previews/SynonymsReadingEnPreview.vue');
    const SynonymsRussianLanguagePreview = () => import('../../games/games-previews/SynonymsRussianLanguagePreview.vue');
    const AntonymsPreview = () => import('../../games/games-previews/AntonymsPreview.vue');
    const ClassificationsPreview = () => import('../../games/games-previews/Classifications.vue');
    const SoundCouplesPreview = () => import('../../games/games-previews/SoundCouples.vue');
    const FourthOnePreview = () => import('../../games/games-previews/FourthOne.vue');
    const SearchPreview = () => import('../../games/games-previews/Search.vue');
    const EquationOnlinePreview = () => import('../../games/games-previews/EquationOnlinePreview.vue');
    const DigitCouplesPreview = () => import('../../games/games-previews/DigitCouplesPreview.vue');
    const MemoryPreview = () => import('../../games/games-previews/MemoryPreview.vue');
    const RootsAndDegreesPreview = () => import('../../games/games-previews/RootsAndDegreesPreview.vue');
    const RootsAndSquaresPreview = () => import('../../games/games-previews/RootsAndDegreesPreview.vue');
    const ExpressionsPreview = () => import('../../games/games-previews/ExpressionsPreview.vue');
    const LonerPreview = () => import('../../games/games-previews/LonerPreview');
    const LonerBonusGamesPreview = () => import('../../games/games-previews/LonerBonusGamesPreview');
    const SchultePreview = () => import('../../games/games-previews/SchultePreview.vue');
    const MemorizePreview = () => import('../../games/games-previews/MemorizePreview.vue');
    const KeenEyePreview = () => import('../../games/games-previews/KeenEyePreview.vue');
    const NumericalNetworkPreview = () => import('../../games/games-previews/NumericalNetworkPreview.vue');
    const MemoPreview = () => import('../../games/games-previews/MemoPreview.vue');
    const RevivedNumbersPreview = () => import('../../games/games-previews/RevivedNumbersPreview.vue');
    const AssociationsPreview = () => import('../../games/games-previews/AssociationsPreview.vue');
    const WhoIsWhoPreview = () => import('../../games/games-previews/WhoIsWhoPreview.vue');
    const SecretsOfCiceroPreview = () => import('../../games/games-previews/SecretsOfCiceroPreview.vue');
    const VocabularyWordsPreview = () => import('../../games/games-previews/VocabularyWordsPreview.vue');
    const VocabularyMemoPreview = () => import('../../games/games-previews/VocabularyWordsPreview.vue');
    const CosmoTourPreview = () => import('../../games/games-previews/CosmoTourPreview');
    const ChameleonPreview = () => import('../../games/games-previews/ChameleonPreview');
    const HandsUpPreview = () => import('../../games/games-previews/HandsUpPreview');
    const MentalDrawingPreview = () => import('../../games/games-previews/MentalDrawingPreview');
    const RepeatAfterMePreview = () => import('../../games/games-previews/RepeatAfterMePreview');
    const CorrectiveSamplesPreview = () => import('../../games/games-previews/CorrectiveSamplesPreview');
    const ChainsBonusGamePreview = () => import('../../games/games-previews/ChainsBonusGamePreview.vue');
    const ScoutPreview = () => import('../../games/games-previews/ScoutPreview');
    const DiadaPreview = () => import('../../games/games-previews/DiadaPreview');
    const AlpariPreview = () => import('../../games/games-previews/AlpariPreview.vue');
    const VisionFieldReadingEnPreview = () => import('../../games/games-previews/VisionFieldReadingEnPreview.vue');
    const DivideItRightPreview = () => import('../../games/games-previews/DivideItRightPreview.vue');
    const DivideUnstressedVowelsPreview = () => import('../../games/games-previews/DivideUnstressedVowelsPreview.vue');
    const WordStructurePreview = () => import('../../games/games-previews/WordStructurePreview.vue');
    const SentenceParsingPreview = () => import('../../games/games-previews/SentenceParsingPreview.vue');
    const VocabularyWordsRusPreview = () => import('../../games/games-previews/VocabularyWordsRusPreview.vue');
    const WordDrumPreview = () => import('../../games/games-previews/WordDrumPreview.vue');
    const ChooseItRightPreview = () => import('../../games/games-previews/ChooseItRightPreview.vue');
    const LettersSoundsSyllablesPreview = () => import('../../games/games-previews/LettersSoundsSyllablesPreview.vue');
    const TransferSyllablesPreview = () => import('../../games/games-previews/TransferSyllablesPreview.vue');
    const TransferSyllablesSchoolPreparingPreview = () => import('../../games/games-previews/TransferSyllablesSchoolPreparingPreview.vue');
    const HardSoftConsonantsPreview = () => import('../../games/games-previews/HardSoftConsonantsPreview.vue');
    const HardSoftConsonantsSchoolPreparingPreview = () => import('../../games/games-previews/HardSoftConsonantsSchoolPreparingPreview.vue');
    const VocabularyMemoRusPreview = () => import('../../games/games-previews/VocabularyMemoRusPreview.vue');
    const OrthographPreview = () => import('../../games/games-previews/OrthographPreview.vue');
    const TranscriptionInWordPreview = () => import('../../games/games-previews/TranscriptionInWordPreview.vue');
    const VoicedAndDeafConsonantsPreview = () => import('../../games/games-previews/VoicedAndDeafConsonantsPreview.vue');
    const PartsOfSpeechPreview = () => import('../../games/games-previews/PartsOfSpeechPreview.vue');
    const ParsingSentencePartsSpeechPreview = () => import('../../games/games-previews/ParsingSentencePartsSpeechPreview.vue');
    const SortOneManyPreview = () => import('../../games/games-previews/SortOneManyPreview.vue');
    const GenericWordsPreview = () => import('../../games/games-previews/GenericWordsPreview.vue');
    const VerbTensesPreview = () => import('../../games/games-previews/VerbTensesPreview.vue');
    const PunctuationMarksPreview = () => import('../../games/games-previews/PunctuationMarksPreview.vue');
    const AlphabetPreview = () => import('../../games/games-previews/AlphabetPreview.vue');
    const ConnectThePuzzlesPreview = () => import('../../games/games-previews/ConnectThePuzzlesPreview.vue');
    const AntonymsRussianLanguagePreview = () => import('../../games/games-previews/AntonymsRussianLanguagePreview.vue');

    import UserApi from '../../../api/user/user';
    import trainer from '../../../utils/trainer/trainer';

    export default {
        props: {
            exercise: Object,
            index: Number,
            userId: Number,
        },
        data() {
            return {
                isLoading: false,
            };
        },
        components: {
            ConnectThePuzzlesPreview,
            AddSubPreview,
            FlashCardsPreview,
            MultDivPreview,
            TabularMultiplicationPreview,
            EquationPreview,
            FactorizationPreview,
            EquationMultiplicationPreview,
            AnzanPreview,
            PuzzlePreview,
            CouplesPreview,
            CouplesReadingEnPreview,
            ChainsPreview,
            ChainsReadingEnPreview,
            WordsFieldPreview,
            WordsFieldReadingEnPreview,
            ScannerPreview,
            ShutterPreview,
            ShutterReadingEnPreview,
            ShutterRussianLanguagePreview,
            AnagramsPreview,
            TextsPreview,
            LettersFieldPreview,
            AntonymsRussianLanguagePreview,
            CatchWordReadingEnPreview,
            CatchWordPreview,
            MatrixPreview,
            NavigatorPreview,
            SynonymsPreview,
            SynonymsReadingEnPreview,
            SynonymsRussianLanguagePreview,
            AntonymsPreview,
            ClassificationsPreview,
            SoundCouplesPreview,
            FourthOnePreview,
            SearchPreview,
            EquationOnlinePreview,
            DigitCouplesPreview,
            MemoryPreview,
            ExpressionsPreview,
            RootsAndDegreesPreview,
            RootsAndSquaresPreview,
            SchultePreview,
            MemorizePreview,
            KeenEyePreview,
            NumericalNetworkPreview,
            LonerPreview,
            LonerBonusGamesPreview,
            MemoPreview,
            RevivedNumbersPreview,
            AssociationsPreview,
            WhoIsWhoPreview,
            SecretsOfCiceroPreview,
            VocabularyWordsPreview,
            VocabularyMemoPreview,
            CosmoTourPreview,
            ChameleonPreview,
            HandsUpPreview,
            MentalDrawingPreview,
            RepeatAfterMePreview,
            DiadaPreview,
            CorrectiveSamplesPreview,
            ChainsBonusGamePreview,
            ScoutPreview,
            AlpariPreview,
            VisionFieldReadingEnPreview,
            TransferSyllablesPreview,
            TransferSyllablesSchoolPreparingPreview,
            HardSoftConsonantsPreview,
            HardSoftConsonantsSchoolPreparingPreview,
            VocabularyMemoRusPreview,
            OrthographPreview,
            TranscriptionInWordPreview,
            AlphabetPreview,
            DivideItRightPreview,
            DivideUnstressedVowelsPreview,
            WordStructurePreview,
            SentenceParsingPreview,
            VocabularyWordsRusPreview,
            WordDrumPreview,
            ChooseItRightPreview,
            LettersSoundsSyllablesPreview,
            VoicedAndDeafConsonantsPreview,
            PartsOfSpeechPreview,
            ParsingSentencePartsSpeechPreview,
            GenericWordsPreview,
            VerbTensesPreview,
            SortOneManyPreview,
            PunctuationMarksPreview,
        },
        mixins: [trainer],
        methods: {
            getPreview(game) {
                switch (game) {
                    case 'MultiplicationAndDivision':
                    case 'MultiplicationAndDivisionMathMagic':
                        return 'mult-div-preview';
                    case 'FlashCards':
                    case 'InteractiveFlashCards':
                        return 'flash-cards-preview';
                    case 'AdditionAndSubtraction':
                    case 'AdditionAndSubtractionWithTime':
                    case 'AdditionAndSubtractionMathMagic':
                        return 'add-sub-preview';
                    case 'Equation':
                        return 'equation-preview';
                    case 'Factorization':
                        return 'factorization-preview';
                    case 'EquationMultiplication':
                        return 'equation-multiplication-preview';
                    case 'Anzan':
                        return 'anzan-preview';
                    case 'Puzzle':
                        return 'puzzle-preview';
                    case 'Couples':
                    case 'CouplesReadingEn':
                        return 'couples-preview';
                    case 'Chains':
                    case 'ChainsMemoryDevelopment':
                    case 'ChainsReadingEn':
                        return 'chains-preview';
                    case 'WordsField':
                    case 'WordsFieldOnline':
                    case 'WordsFieldReadingEn':
                        return 'words-field-preview';
                    case 'Scanner':
                    case 'ScannerReadingEn':
                        return 'scanner-preview';
                    case 'Shutter':
                    case 'ShutterOnline':
                    case 'ShutterReadingEn':
                        return 'shutter-preview';
                    case 'Anagrams':
                    case 'AnagramsOnline':
                        return 'anagrams-preview';
                    case 'Texts':
                    case 'TextsOnline':
                        return 'texts-preview';
                    case 'LettersField':
                    case 'LettersFieldOnline':
                    case 'LettersFieldReadingEn':
                        return 'letters-field-preview';
                    case 'CatchWord':
                    case 'CatchWordOnline':
                    case 'CatchWordReadingEn':
                        return 'catch-word-preview';
                    case 'Matrix':
                        return 'matrix-preview';
                    case 'Navigator':
                    case 'NavigatorBonusGames':
                    case 'NavigatorMemoryDevelopment':
                        return 'navigator-preview';
                    case 'Synonyms':
                    case 'SynonymsOnline':
                        return 'synonyms-preview';
                    case 'Antonyms':
                        return 'antonyms-preview';
                    case 'Classifications':
                        return 'classifications-preview';
                    case 'SoundCouples':
                        return 'sound-couples-preview';
                    case 'FourthOne':
                        return 'fourth-one-preview';
                    case 'Search':
                        return 'search-preview';
                    case 'EquationOnline':
                        return 'equation-online-preview';
                    case 'DigitCouples':
                        return 'digit-couples-preview';
                    case 'Memory':
                        return 'memory-preview';
                    case 'Expressions':
                        return 'expressions-preview';
                    case 'RootsAndDegrees':
                        return 'roots-and-degrees-preview';
                    case 'RootsAndSquares':
                        return 'roots-and-squares-preview';
                    case 'Schulte':
                    case 'SchulteReadingEn':
                        return 'schulte-preview';
                    case 'Memorize':
                        return 'memorize-preview';
                    case 'KeenEye':
                    case 'KeenEyeMemoryDevelopment':
                    case 'KeenEyeBonusGames':
                        return 'keen-eye-preview';
                    case 'NumericalNetwork':
                        return 'numerical-network-preview';
                    case 'Loner':
                    case 'LonerMemoryDevelopment':
                        return 'loner-preview';
                    case 'LonerBonusGames':
                        return 'loner-bonus-games-preview';
                    case 'CouplesMemoryDevelopment':
                        return 'couples-preview';
                    case 'Memo':
                    case 'MemoBonusGames':
                        return 'memo-preview';
                    case 'RevivedNumbers':
                        return 'revived-numbers-preview';
                    case 'Associations':
                        return 'associations-preview';
                    case 'WhoIsWho':
                        return 'who-is-who-preview';
                    case 'SecretsOfCicero':
                        return 'secrets-of-cicero-preview';
                    case 'VocabularyWords':
                        return 'vocabulary-words-preview';
                    case 'VocabularyMemo':
                        return 'vocabulary-memo-preview';
                    case 'CosmoTour':
                        return 'cosmo-tour-preview';
                    case 'Chameleon':
                        return 'chameleon-preview';
                    case 'HandsUp':
                        return 'hands-up-preview';
                    case 'MentalDrawing':
                        return 'mental-drawing-preview';
                    case 'RepeatAfterMe':
                        return 'repeat-after-me-preview';
                    case 'CorrectiveSamples':
                    case 'CorrectiveSamplesWithTime':
                        return 'corrective-samples-preview';
                    case 'ChainsBonusGame':
                    case 'ChainsBonusGameWithTime':
                    case 'ChainsBonusGameWithoutTime':
                        return 'chains-bonus-game-preview';
                    case 'Scout':
                        return 'scout-preview';
                    case 'Diada':
                        return 'diada-preview';
                    case 'Alpari':
                        return 'alpari-preview';
                    case 'AntonymsRussianLanguage':
                        return 'antonyms-russian-language-preview'
                    case 'VisionFieldReadingEn':
                        return 'vision-field-reading-en-preview';
                    case 'SynonymsReadingEn':
                        return 'synonyms-reading-en-preview';
                    case 'SynonymsRussianLanguage':
                        return 'synonyms-russian-language-preview';
                    case 'DivideItRight':
                        return 'divide-it-right-preview';
                    case 'DivideUnstressedVowels':
                        return 'divide-unstressed-vowels-preview';
                    case 'WordStructure':
                        return 'word-structure-preview';
                    case 'ShutterRussianLanguage':
                      return 'shutter-russian-language-preview';
                    case 'SentenceParsing':
                        return 'sentence-parsing-preview';
                    case 'VocabularyWordsRus':
                        return 'vocabulary-words-rus-preview';
                    case 'WordDrum':
                        return 'word-drum-preview';
                    case 'ChooseItRight':
                        return 'choose-it-right-preview';
                    case 'LettersSoundsSyllables':
                        return 'letters-sounds-syllables-preview';
                    case 'TransferSyllables':
                        return 'transfer-syllables-preview';
                    case 'TransferSyllablesSchoolPreparing':
                        return 'transfer-syllables-school-preparing-preview';
                    case 'HardSoftConsonants':
                        return 'hard-soft-consonants-preview';
                    case 'HardSoftConsonantsSchoolPreparing':
                        return 'hard-soft-consonants-school-preparing-preview';
                    case 'VocabularyMemoRus':
                        return 'vocabulary-memo-rus-preview';
                    case 'Orthograph':
                        return 'orthograph-preview';
                    case 'TranscriptionInWord':
                        return 'transcription-in-word-preview';
                    case 'VoicedAndDeafConsonants':
                        return 'voiced-and-deaf-consonants-preview';
                    case 'PartsOfSpeech':
                        return 'parts-of-speech-preview';
                    case 'ParsingSentencePartsSpeech':
                        return 'parsing-sentence-parts-speech-preview';
                    case 'GenericWords':
                        return 'generic-words-preview';
                    case 'VerbTenses':
                        return 'verb-tenses-preview';
                    case 'SortOneMany':
                        return 'sort-one-many-preview';
                    case 'PunctuationMarks':
                        return 'punctuation-marks-preview';
                    case 'Alphabet':
                        return 'alphabet-preview';
                    case 'ConnectThePuzzles':
                        return 'connect-the-puzzles-preview';
                }
            },
            countExercise(exercise) {
                this.isLoading = true;
                UserApi.countExercise(this.userId, exercise.id)
                    .then(stat => {
                        this.$emit('statUpdated', stat, this.index);
                        this.isLoading = false;
                    })
                    .catch(err => {
                        this.isLoading = false;
                        this.$toasted.error(this.$root.$t('errors.error_has_occurred'));
                    });
            },
            isExerciseCompleted(exercise) {
                return !!(exercise.allStats[0] ? exercise.allStats[0].isCompleted : false);
            },
        },
        computed: {
            imageSrcString() {
                if (this.exercise.slug.includes('Online')) {
                    return `/imgs/game-icons/${this.exercise.slug.substring(
                        0,
                        this.exercise.slug.length - 'Online'.length
                    )}.png`;
                }
                if (this.exercise.slug.includes('MathMagic')) {
                    return `/imgs/game-icons/${this.exercise.slug.substring(
                        0,
                        this.exercise.slug.length - 'MathMagic'.length
                    )}.png`;
                }
                if (this.exercise.slug.includes('MemoryDevelopment')) {
                    return `/imgs/game-icons/${this.exercise.slug.substring(
                        0,
                        this.exercise.slug.length - 'MemoryDevelopment'.length
                    )}.png`;
                }
                if (this.exercise.slug.includes('Multiplication')) {
                    return `/imgs/game-icons/${this.exercise.slug.substring(
                        0,
                        this.exercise.slug.length - 'Multiplication'.length
                    )}.png`;
                }
                if (this.exercise.slug.includes('ReadingEn')) {
                    return `/imgs/game-icons/${this.exercise.slug.substring(
                        0,
                        this.exercise.slug.length - 'ReadingEn'.length
                    )}.png`;
                }
                if (this.exercise.slug.includes('RussianLanguage')) {
                    return `/imgs/game-icons/${this.exercise.slug.substring(
                        0,
                        this.exercise.slug.length - 'RussianLanguage'.length
                    )}.png`;
                }
                if (this.exercise.slug === 'RootsAndSquares') {
                    return `/imgs/game-icons/RootsAndDegrees.png`;
                }
                return `/imgs/game-icons/${this.exercise.slug}.png`;
            },
        },
    };
</script>

<style lang="scss">
    .exercise {
        font-size: 16px;
        line-height: 24px;
        margin-top: 30px;
    }

    .exercise__header {
        display: flex;
        align-items: center;

        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
    }

    .exercise__item {
        margin-top: 10px;
    }

    .exercise__done {
        color: $hsl-color-green-58;
        display: flex;
        align-items: center;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
    }

    .exercise__done-icon {
        margin-right: 10px;
    }

    .exercise__image-box {
        margin-right: 16px;
        width: 60px;
        height: 60px;
        background-color: $x-color-white;
        border-radius: $border-radius-10;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 12px 8px;
        box-sizing: border-box;
    }

    .exercise__image {
        max-height: 100%;
        max-width: 100%;
    }
</style>
